<!--
 * @Description: 
 * @LastEditors: Wangyy
 * @Author: Wangyy
-->
<template>
  <bottom-footer></bottom-footer>
</template>
<script>
import BottomFooter from '@/components/index/bottomFooter'
export default {
  data() {
    return {}
  },
  components: {
    BottomFooter
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/components/globFooter.vue